import { useQuery } from "@tanstack/react-query";

import { getCropMixComposerCommercialMixes } from "services";

import { GET_CROP_MIX_COMPOSER_COMMERCIAL_MIXES } from "consts";

import { CropMixComposerCommercialMix } from "models";

export const useGetCropMixComposerCommercialMixes = (mixId: string) =>
  useQuery<CropMixComposerCommercialMix[]>({
    queryKey: [GET_CROP_MIX_COMPOSER_COMMERCIAL_MIXES, mixId],
    queryFn: () => getCropMixComposerCommercialMixes({ mixId }),
    enabled: !!mixId,
  });
